import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import AttributeChip from '../attributeChip';
import ActionButton from '../actionButton';
import TextBoxWithTooltip from '../textBoxWithTooltip';
import { ACTION_BUTTON_TYPES } from '../actionButton/config';
import { isArrayEmpty } from '../../../utility/helpers';

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    display: 'grid',
    width: '100%',
    gap: 24,
  },
  attributeWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: 438,
  },
  attributeName: {
    marginBottom: spacing(3),
  },
  reviewsWrapper: {
    display: 'grid',
    width: '100%',
    gap: 8,
  },
  reviewWrapper: {
    display: 'grid',
    gridTemplateColumns: '1fr 70px',
    alignItems: 'center',
    width: '100%',
    gap: 8,
  },
  review: {
    backgroundColor: 'transparent',
    position: 'relative',
    zIndex: 11,
    minWidth: 0,
  },
  reviewScore: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  viewAnswersButton: {
    width: 28,
    height: 28,
  },
  viewAnswersIcon: {
    width: 16,
    height: 16,
  },
  reviewName: {
    fontSize: 12,
    lineHeight: '14px',
  },
}));

const EmployeeCycleAttributes = ({
  translations,
  attributes = [],
  onPreviewAnswers,
}) => {
  const classes = useStyles();

  const handleAnswersPreview = useCallback(
    (attribute, stepType) => () => {
      onPreviewAnswers(attribute, stepType);
    },
    [onPreviewAnswers]
  );

  return (
    <div className={classes.root}>
      {!isArrayEmpty(attributes) &&
        attributes.map(attribute => {
          const { id, name, color, isTextReply } = attribute;
          return (
            <div key={`reviewGroup_${id}`} className={classes.attributeWrapper}>
              <TextBoxWithTooltip
                className={classes.attributeName}
                variant="h5"
                text={name}
              />
              <div className={classes.reviewsWrapper}>
                {attribute.reviews.map(review => (
                  <div
                    key={`review_${review.id}`}
                    className={classes.reviewWrapper}
                  >
                    <AttributeChip
                      {...attribute}
                      attributeNameClass={classes.reviewName}
                      attribute={review}
                      name={review.name}
                      color={
                        review.score || attribute.isTextReply
                          ? color
                          : undefined
                      }
                      isTextReply={attribute.isTextReply}
                      isSelected
                    />
                    <div className={classes.reviewScore}>
                      {isTextReply && review.hasReplies && (
                        <ActionButton
                          className={classes.viewAnswersButton}
                          iconButtonClass={classes.viewAnswersButton}
                          iconClass={classes.viewAnswersIcon}
                          type={ACTION_BUTTON_TYPES.COMMENT}
                          tooltipText={translations.viewAnswers}
                          onClickHandler={handleAnswersPreview(
                            attribute,
                            review.id
                          )}
                        />
                      )}
                      {isTextReply && !review.hasReplies && (
                        <Typography variant="h5">-</Typography>
                      )}
                      {!isTextReply && (
                        <Typography variant="h5">{`${
                          review.score ? review.score : '-'
                        } ${review.score ? '/' : ''} ${
                          review.score ? 10 : ''
                        }`}</Typography>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
    </div>
  );
};

EmployeeCycleAttributes.propTypes = {
  translations: PropTypes.object.isRequired,
  attributes: PropTypes.arrayOf(PropTypes.object),
  onPreviewAnswers: PropTypes.func.isRequired,
};

export default EmployeeCycleAttributes;
